import { render } from "./QuizOrder.vue?vue&type=template&id=59aa0206"
import script from "./QuizOrder.vue?vue&type=script&lang=js"
export * from "./QuizOrder.vue?vue&type=script&lang=js"
script.render = render

export default script